import type { BehavioralFlags } from '@/types';

/** Plain-language labels for active proctor observation flags. */
export const PROCTOR_FLAG_LABELS: { key: keyof BehavioralFlags; label: string }[] = [
  { key: 'lookingAway', label: 'Gaze off screen' },
  { key: 'noFaceDetected', label: 'Face/head not toward camera' },
  { key: 'multipleFaces', label: 'Multiple people in view' },
  { key: 'suspiciousMovement', label: 'Unusual movement' },
  { key: 'headMovementExcessive', label: 'Head turned from camera' },
];

export function normalizeBehavioralFlags(
  raw: Record<string, unknown> | BehavioralFlags | null | undefined
): BehavioralFlags | undefined {
  if (!raw || typeof raw !== 'object') return undefined;

  const r = raw as Record<string, unknown>;
  return {
    lookingAway: Boolean(r.lookingAway ?? r.looking_away),
    multipleFaces: Boolean(r.multipleFaces ?? r.multiple_faces),
    noFaceDetected: Boolean(r.noFaceDetected ?? r.no_face_detected),
    suspiciousMovement: Boolean(r.suspiciousMovement ?? r.suspicious_movement),
    headMovementExcessive: Boolean(r.headMovementExcessive ?? r.head_movement_excessive),
  };
}

export function activeProctorLabels(flags?: BehavioralFlags | null): string[] {
  if (!flags) return [];
  return PROCTOR_FLAG_LABELS.filter(({ key }) => flags[key]).map(({ label }) => label);
}
